import { Input } from 'antd';
import styled from 'styled-components';


export const Input3D = styled(Input)`
    background: #FFFFFF;
    height: 50px;
    font-family: "Rogan";
    border: 1px solid #D8D8D8;
    box-sizing: border-box;

    .ant-input{
        font-size: 1.25rem;
    }
`;
